import { createPinia } from 'pinia'
import { definePreset } from '@primevue/themes'
import { defineRule } from 'vee-validate'
import { required } from '@vee-validate/rules'
import Aura from '@primevue/themes/aura'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'
import { createApp } from 'vue'

import App from './App.vue'
import './assets/main.css'
import 'primeicons/primeicons.css'
import i18n from './libs/i18n'
import { createSentry } from './libs/sentry'
import router from './router'

defineRule('required', required)

const NomNomPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50:  '#f3fcf7',
            100: '#def7e8',
            200: '#bcf0d2',
            300: '#92e8b5',
            400: '#5ede93',
            500: '#2ed573',
            600: '#25ac5d',
            700: '#1f8449',
            800: '#0f6131',
            900: '#103720',
            950: '#0b2215',
        }
    }
})

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(ConfirmationService)
app.use(ToastService)
app.directive('tooltip', Tooltip)
app.use(PrimeVue, {
    theme: {
        preset: NomNomPreset,
        options: {
            cssLayer: { name: 'primevue', order: 'theme, base, primevue' },
            darkModeSelector: '.dark',
        },
    },
})

createSentry(app)
app.use(router)
router.isReady().then(() => app.mount('#app'))
